import { NgModule, Type } from '@angular/core';

import { AnonymousComponent } from './anonymous.component';
import { CommonModule } from '@angular/common';

const components: Type<any>[] = [AnonymousComponent];

@NgModule({
  imports: [CommonModule],
  declarations: [components],
  exports: [components],
})
export class AnonymousModule { }
